var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSbpLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 42 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#190b3d",
  d: "M41.5 9.355v5.868h-2.08v-4.116h-2v4.116h-2.08V9.354z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#190b3d",
  fillRule: "evenodd",
  d: "M31.074 15.432c1.86 0 3.242-1.15 3.242-2.893 0-1.687-1.02-2.783-2.723-2.783-.786 0-1.435.279-1.924.76.117-.995.952-1.721 1.87-1.721l1.81-.003.902-1.742s-2.004.046-2.936.046c-2.13.037-3.567 1.988-3.567 4.358 0 2.76 1.402 3.978 3.326 3.978m.011-4.133c.69 0 1.17.457 1.17 1.24 0 .704-.426 1.284-1.17 1.286-.712 0-1.19-.538-1.19-1.274 0-.783.478-1.252 1.19-1.252",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#190b3d",
  d: "M26.056 13.259s-.491.285-1.224.339c-.843.025-1.594-.512-1.594-1.465 0-.93.663-1.463 1.573-1.463.558 0 1.296.39 1.296.39s.54-1 .82-1.499c-.513-.391-1.195-.606-1.989-.606-2.002 0-3.554 1.316-3.554 3.166 0 1.873 1.458 3.16 3.554 3.12.586-.022 1.394-.23 1.887-.548z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#5b57a2",
  d: "m.5 5.224 2.883 5.195v3.168l-2.88 5.185z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#d90751",
  d: "m11.57 8.529 2.7-1.67 5.53-.005-8.23 5.083z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fab718",
  d: "m11.554 5.193.015 6.878-2.89-1.79V0z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#ed6f26",
  d: "m19.8 6.854-5.53.005-2.716-1.666L8.68 0z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#63b22f",
  d: "M11.57 18.801v-3.337l-2.89-1.756V24z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#1487c9",
  d: "M14.264 17.147 3.383 10.419.5 5.224 19.788 17.14z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#017f36",
  d: "m8.682 24 2.887-5.199 2.695-1.654 5.524-.006z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#984995",
  d: "m.503 18.772 8.2-5.064-2.756-1.705-2.564 1.584z"
})));
export default SvgSbpLogo;